import { Box, FelaCSS } from '@bridebook/ui';
import IconBudget, {
  IProps as IconBudgetProps,
} from '@bridebook/ui/src/components/svg/icon-budget';
import { PricingCategory } from '@bridebook/web/app-shared/lib/supplier/types';
import componentStyles from './pricing-icon.style';

const DEFAULT_ICON_WIDTH = 20;

interface IProps {
  pricingCategory?: PricingCategory;
  iconProps?: IconBudgetProps;
  style?: FelaCSS;
}

const PricingIcon = ({ iconProps = {}, pricingCategory, ...restProps }: IProps) => {
  const styles = componentStyles(iconProps.width || DEFAULT_ICON_WIDTH);

  const defaultIconProps: IconBudgetProps = {
    borderColor: 'space60',
    fillColor: pricingCategory ? 'white' : 'transparent',
    width: DEFAULT_ICON_WIDTH,
  };

  const iconPropsCombined = {
    ...defaultIconProps,
    ...iconProps,
    style: {
      ...iconProps.style,
      ...styles.stackedIcon,
    },
  };

  return (
    <Box {...restProps}>
      {pricingCategory ? (
        <Box style={styles.stackedIconsWrap}>
          {[...Array(pricingCategory.valueOf())].map((_, index) => (
            <IconBudget key={index} {...iconPropsCombined} />
          ))}
        </Box>
      ) : (
        <IconBudget {...iconPropsCombined} />
      )}
    </Box>
  );
};

export default PricingIcon;
